export default "<footer>\r\n  footer works!\r\n</footer>\r\n"